export default {
  page: 'Home page',
  system: 'system managerment',
  userAdmin: 'User management',
  userList: 'User list',
  userName: ' User name',
  userPass: 'password',
  email: 'email',
  userPhone: 'phone number',
  userType: 'account type',
  roleName: 'role',

  checkKey: 'Looking Key',
  selectuserType: 'Select account type',
  createAcct: 'updater',
  makeupAmountLimit: 'makeupAmountLimit',
  createTime: 'update time',
  userState: 'Account status',
  operation: 'operation',
  addUser: 'add user',
  inputtext: 'please enter money',
  inactive: 'Disable',
  active: 'active',
  cancel: ' cancel',
  confirm: ' confirm',
  changePass: 'change password',
  resetPass: 'Reset payment password',
  resetSignPass: 'Reset sign password',
  oblPass: 'old password',
  newPass: 'new password',
  addFormName: 'Please enter the username, the username cannot be empty',
  addFormPass: 'Please enter the password, the password cannot be empty',
  addFormId: 'Please enter id',
  addFormType: 'Please enter account type',
  addFormPhone: 'Please enter the phone number, the phone number cannot be empty',
  addFormEmail: 'Please enter the email, the email cannot be empty',
  Administrator: 'administrator',
  Agency: 'agent',
  Commercial: 'merchant',
  addrefError: 'Invalid parameter',

  changerefError:
    'The parameter is invalid or the new password is the same as the original password！',
  checkPassErr: 'Please enter the correct password, consisting of 6-25 characters',
  checkNameErr: 'The legal user name consists of 4-20 digits and letters',
  checkEmailErr: 'Please enter a legal email address, for example: wangyi@163.com',
  checkPhoneErr: 'Please enter a legal mobile phone number, for example: 0-3(5,7,8,9)-00000000',
  hintmessage: `Whether to reset the user's password`,
  electwellattype: 'select wallet type',
  refreshCacheHint: 'Whether to refresh the cache'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/accountmanager.js